import { render, staticRenderFns } from "./BookViewToggle.vue?vue&type=template&id=160af2dc&scoped=true&"
import script from "./BookViewToggle.vue?vue&type=script&lang=js&"
export * from "./BookViewToggle.vue?vue&type=script&lang=js&"
import style0 from "./BookViewToggle.vue?vue&type=style&index=0&id=160af2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160af2dc",
  null
  
)

export default component.exports